<template>
  <div
    class="Earth2Charts"
    v-loading="loading"
    element-loading-text="拼命加载中..."
    element-loading-background="rgba(0, 0, 0, 0)"
    @mousedown="down($event)"
  >
    <div class="echarts" :id="Configuration.id"></div>
    <div v-show="backShow" class="back" @click="backToFront">返 回</div>
  </div>
</template>

<script>
import * as Echarts from 'echarts';
import provinceCoordinate from './provinceCoordinate';
import colors from './colors';
import { map } from 'highcharts';
// const fs = require('fs');
// const path = require('path');

import { getFilterValue } from '../../../../utils/tool';

export default {
  name: 'Earth2Charts',
  components: {},
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echarts: null,
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      geoJson: {},
      parentInfo: [
        {
          // cityName: '全国',
          code: 100000,
        },
      ],
      currentIndex: 0,
      timeTitle: ['2015', '2016', '2017', '2018', '2019'],
      mapData: [],
      sum: 0,
      pointData: [],
      cityCode: 100000,
      backShow: false,
      loading: true,
      points: [], // 动态的点数据
      linesCoords: [], // 迁徙的线的坐标
      mapMigrate: {}, // 数据
      AMapKey: '',
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          this.throttle_resizeEcharts();
        } else if (this.Configuration.isMoving) {
          this.debounce_resizeEcharts();
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
    // 默认取api参数
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    this.AMapKey = this.Configuration?.propertyData?.MapKey?.value;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    this.params = eval('(' + params + ')');
    this.paramsCopy = eval('(' + params + ')');
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.destroyEcharts();
    this.unRegisterDebounceAndThrottle();
  },
  computed: {
    // 动态的点坐标
    points() {
      return provinceCoordinate.map(item => {
        return { value: item.value };
      });
    },
    // 迁徙的线坐标
    linesCoords() {
      return provinceCoordinate.map(item => {
        return {
          coords: [item.value, this.Configuration.propertyData.mapMigrate.value.centerCoordinate],
        };
      });
    },
  },
  methods: {
    down(e) {
      e.stopPropagation();
    },
    getFilterValue(e) {
      return getFilterValue(e);
    },
    backToFront() {
      if (this.parentInfo.length === 1) {
        return;
      }
      this.parentInfo.pop();
      this.cityCode = this.parentInfo[this.parentInfo.length - 1].code;
      this.cityCode == 100000 ? (this.backShow = false) : (this.backShow = true);
      this.setEchartsOptions();
      this.updateEcharts();
    },
    registerDebounceAndThrottle() {
      this.debounce_resizeEcharts = this.$_.debounce(this.resizeEcharts, 100);
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
      this.throttle_resizeEcharts = this.$_.throttle(this.resizeEcharts, 20);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_resizeEcharts.cancel();
      this.debounce_subscribeConfigurationChange.cancel();
      this.throttle_resizeEcharts.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let mapGrid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let totalNumber = 0;
      let max = 0;
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };
      // let mapMigrate = {};

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      // 获取迁徙数据
      if (this.Configuration.propertyData.mapMigrate.value) {
        this.mapMigrate = this.Configuration.propertyData.mapMigrate.value;
        console.log(this.mapMigrate, '获取的迁徙数据！！！！！！');
      }
      // if (this.Configuration.propertyData.chartsGrid.value) {
      //   grid = this.Configuration.propertyData.chartsGrid.value;
      // }
      if (this.Configuration.propertyData.mapGrid.value) {
        mapGrid = this.Configuration.propertyData.mapGrid.value;
      }
      if (this.Configuration.propertyData.maxValue.value) {
        max = this.Configuration.propertyData.maxValue.value;
      }

      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
        totalNumber = ParamData.totalNumber;
        // todo  totalNumber 静态需要汇总
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }
      console.log(grid);
      console.log(chartColor);
      console.log(fontStyle);
      // console.log(source, 'source getMapData 传入的数据');
      console.log(seriesList);
      // console.log(totalNumber, 'totalNumber 总数值');
      //这里做个切换，全国的时候才显示南海诸岛  只有当注册的名字为china的时候才会显示南海诸岛
      this.getGeoJson(this.cityCode).then(data => {
        this.geoJson = data;
        Echarts.registerMap(this.parentInfo.length === 1 ? 'china' : 'map', this.geoJson);
        this.getMapData(source);
        var xData = [];
        var yData = [];
        var min = this.mapData[this.mapData.length - 1].value;

        if (this.mapData.length === 1) {
          min = 0;
        }

        this.mapData
          .sort((a, b) => {
            return b.value - a.value;
          })
          .forEach(c => {
            if (c.value != 0) {
              xData.unshift(c.name);
              yData.unshift(c.value);
            }
          });
        const RightChartcolors = [
          'rgba(255,158,255,1)',
          'rgba(125,179,133,1)',
          'rgba(240,189,108,1)',
          'rgba(159,130,246,1)',
          'rgba(122,193,168,1)',
          'rgb(123,39,229,1)',
          'rgba(180,80,54,1)',
          'rgba(237,274,102,1)',
          'rgba(219,119,160,1)',
          'rgba(229,115,53,1)',
          'rgba(140,9,44,1)',
          'rgba(237,215,102,1)',
          'rgba(208,119,219,1)',
          'rgba(179,4,88,1)',
          'rgba(240,189,178,1)',
          'rgba(217,219,67,1)',
          'rgba(223,68,56,1)',
          'rgba(229,115,53,1)',
          'rgba(136,109,137,1)',
          'rgba(237,215,102,1)',
        ];
        this.echartsOptions = {
          baseOption: {
            backgroundColor: this.Configuration.propertyData.chartsColor.value.chartBackgroundColor,
            title: [
              {
                left: 'center',
                top: 10,
                text: this.parentInfo[this.parentInfo.length - 1].cityName,
                textStyle: {
                  color: fontStyle.titleColor,
                  fontSize: fontStyle.titleSize,
                },
              },
            ],
            tooltip: {
              // show: false,
              trigger: 'axis',
              axisPointer: {
                type: 'shadow',
              },
              backgroundColor: 'rgba(25, 27, 31,.8)',
              textStyle: {
                color: '#fff',
              },
            },
            // grid: { ...grid, containLabel: true },
            geo: {
              // select: {
              //   label: {
              //     show: true,
              //     color: '#fff',
              //   },
              //   itemStyle: {
              //     areaColor: '#fff',
              //   },
              // },
              map: this.parentInfo.length === 1 ? 'china' : 'map',
              zoom: this.mapMigrate.zoom,
              // roam: true,
              roam: true,
              ...mapGrid,
              tooltip: {
                trigger: 'item',
                backgroundColor: 'rgba(25, 27, 31,.8)',
                textStyle: {
                  color: '#fff',
                },
                borderColor: '#fff',
                formatter: p => {
                  let val = p.value[2];
                  if (window.isNaN(val)) {
                    val = 0;
                  }
                  let txtCon =
                    "<div style='text-align:left'>" + p.name + ':<br />' + seriesList[0] ||
                    '投诉数量' + ':' + val.toFixed(2) + '</div>';
                  return txtCon;
                },
              },
              //地图区域内容的样式以及高亮的样式
              label: {
                normal: {
                  show: false,
                  color: 'rgb(249, 249, 249)', //省份标签字体颜色
                  formatter: p => {
                    switch (p.name) {
                      case '内蒙古自治区':
                        p.name = '内蒙古';
                        break;
                      case '西藏自治区':
                        p.name = '西藏';
                        break;
                      case '新疆维吾尔自治区':
                        p.name = '新疆';
                        break;
                      case '宁夏回族自治区':
                        p.name = '宁夏';
                        break;
                      case '广西壮族自治区':
                        p.name = '广西';
                        break;
                      case '香港特别行政区':
                        p.name = '香港';
                        break;
                      case '澳门特别行政区':
                        p.name = '澳门';
                        break;
                    }
                    return p.name;
                  },
                },
                emphasis: {
                  show: true,
                  color: '#fff',
                },
              },
              // 地图区域的样式以及高亮的样式
              itemStyle: {
                normal: {
                  areaColor: '#24CFF4',
                  borderColor: '#218ac8',
                  borderWidth: 1.3,
                  // shadowBlur: 0,
                  shadowColor: 'rgb(58,115,192)',
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                },
                emphasis: {
                  areaColor: '#25578e',
                  borderColor: '#53D9FF',
                  borderWidth: 1.6,
                  shadowBlur: 25,
                },
              },
            },
            // 左下角的色块
            visualMap: {
              min: 0,
              max: max,
              text: ['High', 'Low'],
              realtime: false,
              calculable: true,
              // 色块的宽高
              itemWidth: 7,
              itemHeight: 50,
              inRange: {
                color: ['lightskyblue', 'yellow', 'orangered'],
              },
              // min: min,
              // max: max,
              // left: '3%',
              // bottom: '5%',
              // seriesIndex: [0],
              // show: true,
              // selectedMode: false,
              // splitList: [
              //   { start: 2000, end: 60000 },
              //   { start: 1500, end: 2000 },
              //   { start: 1000, end: 1500 },
              //   { start: 500, end: 1000 },
              //   { start: 0, end: 500 },
              // ],
              // color: ['#5475f5', '#85daef', '#74e2ca', '#e6ac53', '#9fb5ea'],
              // 开启显示线性颜色对比
              // calculable: true,
              // inRange: {
              //   // color: ['#d1cfe4', '#d1cfe4', '#95c7fd', '#599ff1', '#2a7be7'],
              //   //  color: ['lightskyblue', 'yellow', 'orangered'],
              //   color: [
              //     '#313695',
              //     '#4575b4',
              //     '#74add1',
              //     '#abd9e9',
              //     '#e0f3f8',
              //     '#ffffbf',
              //     '#fee090',
              //     '#fdae61',
              //     '#f46d43',
              //     '#d73027',
              //     '#a50026',
              //   ],
              // color: chartColor,
              // },
              // 色块的宽高
              // itemWidth: 4,
              // itemHeight: 80,
              // 色块文字的颜色
              // textStyle: {
              //   color: '#24CFF4',
              // },
            },
            xAxis: {
              type: 'value',
              scale: true,
              position: 'top',
              boundaryGap: false,
              show: false,
              splitLine: {
                show: false,
              },
              axisLine: {
                show: false,
                lineStyle: {
                  color: '#455B77',
                },
              },
              axisTick: {
                show: false,
              },
              axisLabel: {
                margin: 2,
                textStyle: {
                  color: '#c0e6f9',
                },
              },
            },
            // 控制y轴是否显示
            yAxis: this.mapMigrate.isShowRightChart
              ? {
                  type: 'category',
                  nameGap: 16,
                  axisLine: {
                    show: false,
                    lineStyle: {
                      color: '#455B77',
                    },
                  },
                  axisTick: {
                    show: false,
                  },
                  axisLabel: {
                    //纵坐标刻度标签文字
                    show: true,
                    interval: 'auto',
                    rotate: 0,
                    margin: 8,
                    clickable: false,
                    // formatter: '{value}',
                    textStyle: {
                      color: fontStyle.yAxisColor,
                      fontFamily: 'Arial, Verdana, sans-serif',
                      fontSize: this.$h_Ratio(fontStyle.yAxisSize, this.$store),
                      fontStyle: 'normal',
                      fontWeight: 'normal',
                    },
                  },
                  data: xData,
                }
              : { show: false },
            series: [
              {
                name: this.timeTitle[this.currentIndex] + '年总人数',
                type: 'map',
                geoIndex: 0,
                map: this.parentInfo.length === 1 ? 'china' : 'map',
                roam: true,
                zoom: 1.1,
                tooltip: {
                  trigger: 'item',
                  formatter: p => {
                    let val = p.value;
                    if (p.name == '南海诸岛') return;
                    if (window.isNaN(val)) {
                      val = 0;
                    }
                    let txtCon =
                      "<div style='text-align:left'>" + '投诉数量 ' + ' : ' + val.toFixed(0) + '</div>';
                    return txtCon;
                  },
                },
                label: {
                  //柱状图显示数字
                  normal: {
                    show: true,
                  },
                  emphasis: {
                    show: true,
                  },
                },

                // 控制是否可选
                selectedMode: false,
                data: this.mapData,
              },
              // 动态的点
              this.mapMigrate.isShowMigrate
                ? {
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    showEffectOn: 'render',
                    zlevel: 1,
                    rippleEffect: {
                      period: 15,
                      scale: 4,
                      brushType: 'fill',
                    },
                    hoverAnimation: true,
                    label: {
                      normal: {
                        formatter: '{b}',
                        position: 'right',
                        offset: [15, 0],
                        color: '#1DE9B6',
                        show: false,
                      },
                    },
                    tooltip: {
                      show: false,
                    },
                    itemStyle: {
                      normal: {
                        color: function (i) {
                          return colors[i.dataIndex];
                        },
                        shadowBlur: 10,
                        shadowColor: '#333',
                      },
                    },
                    symbolSize: 6,
                    data: this.points,
                  }
                : null,
              // 运动的线
              this.mapMigrate.isShowMigrate
                ? {
                    type: 'lines',
                    zlevel: 2,
                    effect: {
                      show: true,
                      period: 4, //箭头指向速度，值越小速度越快
                      trailLength: 0.4, //特效尾迹长度[0,1]值越大，尾迹越长重
                      symbol: 'arrow', //箭头图标
                      symbolSize: 4, //图标大小
                    },
                    tooltip: {
                      show: false,
                    },
                    lineStyle: {
                      normal: {
                        color: function (i) {
                          return colors[i.dataIndex];
                        },
                        width: 1, //线条宽度
                        opacity: 0.1, //尾迹线条透明度
                        curveness: 0.3, //尾迹线条曲直度
                      },
                    },
                    data: this.linesCoords,
                  }
                : null,
              // 右侧柱状图图表
              !this.mapMigrate.isShowRightChart
                ? null
                : {
                    type: 'bar',
                    barCategoryGap: '90%',
                    show: false,
                    grid: {
                      ...grid,
                      containLabel: true,
                    },
                    itemStyle: {
                      normal: {
                        color: params => {
                          // console.log(params, 'params params 柱状图图表');
                          var data = xData;
                          // data.sort(function (a, b) {
                          //   return a - b;
                          // });
                          // data.reverse();
                          // console.log(data, 'xData xData 柱状图图表');
                          var statusIndex = 0;
                          data.forEach(function (event, index) {
                            if (event == params.name) {
                              statusIndex = index;
                            }
                          });
                          var colorList = [...RightChartcolors];
                          var colorList2 = [];
                          RightChartcolors.forEach(item => {
                            let c = this.$tinycolor(item).setAlpha(0.05).toRgbString();
                            colorList2.push(c);
                          });
                          var color = new Echarts.graphic.LinearGradient(1, 0, 0, 0, [
                            {
                              offset: 0,
                              color: colorList[statusIndex % 6],
                            },
                            {
                              offset: 1,
                              color: colorList2[statusIndex % 6],
                            },
                          ]);
                          return color; //大概最新的柱子颜色始终一样的 不太理解
                        },
                        label: {
                          //柱状图显示数字
                          show: true, //开启显示
                          position: 'right', //在上方显示
                          textStyle: {
                            //数值样式
                            color: fontStyle.xAxisColor,
                            fontSize: this.$h_Ratio(fontStyle.xAxisSize, this.$store),
                          },
                        },
                        // borderWidth: 2,
                        barBorderRadius: 15,
                      },
                    },
                    series: [
                      {
                        label: {
                          //柱状图显示数字
                          show: true, //开启显示
                          position: 'right', //在上方显示
                          color: '#fff',
                        },
                      },
                    ],
                    tooltip: {
                      backgroundColor: 'rgba(25, 27, 31,0.8)',
                      className: 'echarts-tooltip echarts-tooltip-dark',
                      //提示框组件，鼠标悬浮在图表上，有相应提示框
                      show: true,
                      trigger: 'axis',
                      axisPointer: {
                        type: 'shadow', //可选line、shadow、none
                        shadowStyle: {
                          // 鼠标悬浮图表柱状图背景色
                          color: '#484d5259',
                          width: '1',
                        },
                      },
                      textStyle: {
                        color: '#fff',
                        fontSize: this.$h_Ratio(15, this.$store),
                      },
                      // formatter: v => {
                      //   let val = v;
                      //   if (window.isNaN(val)) {
                      //     val = 0;
                      //   }
                      //   let txtCon =
                      //     "<div style='text-align:left'>" + ':<br />' + seriesList[0] ||
                      //     '人数' + ':' + val.toFixed(0) + '</div>';
                      //   return txtCon;
                      // },
                    },
                    data: yData,
                  },
            ],
          },
        };
        this.createEcharts();
        // 关闭加载
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.staticIntervalTaskID = setInterval(() => {
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.apiIntervalTaskID = setTimeout(async () => {
          console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          this.axios({
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          })
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          this.axios({
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            data: this.params,
            headers: header,
          })
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            console.log('getApiDataResByFilterAndResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 创建 Echarts 需要准备好echartsOptions数据 具有reload效果
    createEcharts() {
      this.destroyEcharts();
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.init(mychartDom, 'dark');
      mychart.setOption(this.echartsOptions);
      //点击前解绑，防止点击事件触发多次
      mychart.off('click');
      mychart.off('georoam');
      // mychart.on('click', this.echartsMapClick);

      mychart.on('georoam', this.$_.debounce(this.handleGeoroam, 100));

      //监听时间切换事件
      mychart.off('timelinechanged');
      mychart.on('timelinechanged', params => {
        this.echartsOptions.timeline.currentIndex = params.currentIndex;
        this.currentIndex = params.currentIndex;
        this.setEchartsOptions();
        this.updateEcharts();
      });
      this.echarts = mychart;
    },
    // 自适应缩放 Echarts 尺寸大小
    resizeEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.resize();
      }
    },
    // 更新 echartsOptions 数据
    updateEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.setOption(this.echartsOptions);
      } else {
        this.createEcharts();
      }
    },
    // 销毁 Echarts 实例
    destroyEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.clear();
        mychart.dispose();
      }
    },
    initA() {
      var that = this;
      return new Promise((resolve, reject) => {
        // 如果已加载直接返回
        if (!window.AMap && !window.AMapUI) {
          this.loadMapJS(
            'https://webapi.amap.com/maps?v=2.0&key=f73ff17cdedd59bd9bee78bb06f543b7&plugin=AMap.DistrictSearch',
            function () {
              that.loadMapJS('https://webapi.amap.com/ui/1.1/main.js', function () {
                resolve(window.AMapUI);
                reject('error');
              });
            },
          );
        } else {
          this.loadMapJS(
            // f73ff17cdedd59bd9bee78bb06f543b7
            `https://webapi.amap.com/maps?v=2.0&key=${this.AMapKey}&plugin=AMap.DistrictSearch`,
            function () {
              that.loadMapJS('https://webapi.amap.com/ui/1.1/main.js', function () {
                resolve(window.AMapUI);
                reject('error');
              });
            },
          );
          // resolve(window.AMap);
        }
      });
    },
    getGeoJson(adcode, childAdcode = '') {
      var that = this;
      return new Promise((resolve, reject) => {
        function insideFun(adcode, childAdcode) {
          that.initA().then(function (res) {
            window.AMapUI?.loadUI(['geo/DistrictExplorer'], DistrictExplorer => {
              var districtExplorer = new DistrictExplorer();
              districtExplorer.loadAreaNode(adcode, function (error, areaNode) {
                if (error) {
                  console.error(error);
                  reject(error);
                  return;
                }
                let Json = areaNode.getSubFeatures();
                if (Json.length === 0) {
                  let parent = areaNode._data.geoData.parent.properties.acroutes;
                  insideFun(parent[parent.length - 1], adcode);
                  return;
                }

                if (childAdcode) {
                  Json = Json.filter(item => {
                    return item.properties.adcode == childAdcode;
                  });
                }
                let mapJson = {
                  features: Json,
                };
                resolve(mapJson);
              });
            });
          });
        }
        insideFun(adcode, childAdcode);
      });
    },
    echartsMapClick(params) {
      if (!params.data) {
        return;
      } else if (params.componentType == 'timeline') {
        return;
      } else {
        //如果当前是最后一级，那就直接return
        if (this.parentInfo[this.parentInfo.length - 1].code == params.data.cityCode) {
          return;
        }
        let data = params.data;
        // console.log('params: ', params);

        this.parentInfo.push({
          cityName: data.name,
          code: data.cityCode,
        });
        this.cityCode = data.cityCode;
        this.cityCode == 100000 ? (this.backShow = false) : (this.backShow = true);
        this.setEchartsOptions();
        this.updateEcharts();
      }
    },
    getMapData(gisData) {
      let mapData = [],
        pointData = [],
        sum = 0;
      this.points = [];
      this.linesCoords = [];
      let currentCenterCoordinate = this.Configuration.propertyData.mapMigrate.value.centerCoordinate;

      // 给点和线赋值
      gisData.forEach(item => {
        provinceCoordinate.forEach(p => {
          if (
            p.name == item.x // || p.cityCode == item.x
          ) {
            this.points.push(p.value);
            this.linesCoords.push([p.value, currentCenterCoordinate]);
          }
        });
      });
      // 给地图赋值
      provinceCoordinate.forEach(item => {
        let flag = false; // 用来标识是否匹配到城市
        gisData.forEach(d => {
          if (
            d.x == item.name
            // || d.x == item.cityCode
          ) {
            mapData.push({
              name: item.name,
              value: Number(d.y),
              cityCode: item.cityCode,
            });
            flag = true;
          }
        });

        // 如果flag为true，就终止本次循环，不进行push操作
        // foreach 中 return false 表示终止本次循环
        // 相当于 for 中的 continue
        if (flag) return false;
        mapData.push({
          name: item.name,
          value: 0,
          cityCode: item.cityCode,
        });
      });

      this.mapData = mapData;
      console.log(this.mapData, '0-0-0-0-0-0-0-0-0');
    },
    loadMapJS(url, callback) {
      var script = document.createElement('script'),
        fn = callback || function () {};

      script.type = 'text/javascript';
      //IE

      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState == 'loaded' || script.readyState == 'complete') {
            script.onreadystatechange = null;

            fn();
          }
        };
      } else {
        //其他浏览器

        script.onload = function () {
          fn();
        };
      }

      script.src = url;
      var first = document.body.firstChild;
      document.body.insertBefore(script, first);
    },
    handleGeoroam(e) {
      console.log(e, '地图缩放和移动', this.echarts.getOption());
      if (e.zoom) {
        let zoom = this.echarts.getOption().geo[0].zoom;
        this.mapMigrate.zoom = zoom.toFixed(3);

        this.debounceMapZoom()();
      }
    },

    debounceMapZoom() {
      return this.$_.debounce(this.commitCurrentPropertyData, 1000);
    },
    commitCurrentPropertyData() {
      console.log('^^^^提交…………');
      this.$store.commit('update_PropertyData', {
        key: 'mapMigrate',
        value: this.mapMigrate,
      });
      // this.$store.commit('update_CurrentConfigration', {
      //  mapMigrate:this.mapMigrate,
      // });
    },
  },

  Configuration: {
    componentTitle: '全国热力图',
    componentName: 'Earth2Charts',
    componentOverViewImg: './img/charts/EarthCharts/Earth2Charts.png',
    id: '',
    style: {
      width: 430,
      height: 330,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(1, 14, 37, 1)',
            'rgba(1, 14, 37, 1)',
            'rgba(1, 14, 37, 1)',
            'rgba(1, 14, 37, 1)',
            'rgba(1, 14, 37, 1)',
            'rgba(1, 14, 37, 1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['投诉数量'],
            source: [
              {
                s: '投诉数量',
                y: 4221, // 人数
                x: '广西壮族自治区', // 省份代码
              },
              {
                s: '投诉数量',
                y: 6701,
                x: '河南省',
              },
              {
                s: '投诉数量',
                y: 5500,
                x: '北京市',
              },
              {
                s: '投诉数量',
                y: 3876, // 人数
                x: '山东省', // 省份代码
              },
              {
                s: '投诉数量',
                y: 7532,
                x: '上海市',
              },
              {
                s: '投诉数量',
                y: 2937,
                x: '四川省',
              },
              {
                s: '投诉数量',
                y: 7231, // 人数
                x: '重庆市', // 省份代码
              },
              {
                s: '投诉数量',
                y: 1734,
                x: '江苏省',
              },
              {
                s: '投诉数量',
                y: 5143,
                x: '浙江省',
              },
              {
                s: '投诉数量',
                y: 4163,
                x: '河北省',
              },
              {
                s: '投诉数量',
                y: 2641,
                x: '湖南省',
              },
              {
                s: '投诉数量',
                y: 5721,
                x: '新疆维吾尔自治区',
              },
              {
                s: '投诉数量',
                y: 4261,
                x: '贵州省',
              },
              {
                s: '投诉数量',
                y: 5243,
                x: '青海省',
              },
              {
                s: '投诉数量',
                y: 2531,
                x: '黑龙江省',
              },
              {
                s: '投诉数量',
                y: 4153,
                x: '内蒙古自治区',
              },
            ],
          },
        },
      },
      // 迁徙图配置
      mapMigrate: {
        label: '地图迁徙图配置',
        propertyComponentName: 'MapMigrateConfiger',

        value: {
          isShowMigrate: false, // 是否显示迁徙图
          centerCoordinate: ['116.3979471', '39.9081726'], // 迁徙图的中心点
          centerCityCode: 110000, // 中心点城市的cityCode
          isShowRightChart: false, // 是否显示右侧图表
          zoom: 1.3, // 地图缩放倍数
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 150,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      // chartsGrid: {
      //   lable: '图表定位',
      //   propertyComponentName: 'ChartsGridConfiger',
      //   value: {
      //     left: '75%',
      //     right: '3%',
      //     bottom: '10%',
      //     top: '5%',
      //   },
      // },
      mapGrid: {
        lable: '地图定位',
        propertyComponentName: 'MapGridConfiger',
        value: {
          left: '25%',
          top: '15%',
        },
      },
      maxValue: {
        value: '8000',
        lable: '热力图最大值',
        propertyComponentName: 'MapMaxSetting',
      },
      showStatus: {
        value: 'norm',
      },
      MapKey: {
        propertyComponentName: 'MapKeyConfiger',
        value: 'f73ff17cdedd59bd9bee78bb06f543b7',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Earth2Charts {
  color: white;
  width: 100%;
  height: 100%;

  .echarts {
    width: 100%;
    height: 100%;
  }
  .back {
    position: absolute;
    left: 25px;
    top: 25px;
    color: rgb(179, 239, 255);
    font-size: 12px;
    cursor: pointer;
    z-index: 100;
  }
}
// 加载样式

:deep().el-loading-spinner {
  .path {
    stroke: #fff !important;
  }

  p {
    display: flex !important;
    align-items: center !important;
    color: #fff !important;
  }
}
</style>
